import { render, staticRenderFns } from "./CustomerNotificationStepFour.vue?vue&type=template&id=148f2da6&scoped=true&"
import script from "./CustomerNotificationStepFour.vue?vue&type=script&lang=js&"
export * from "./CustomerNotificationStepFour.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNotificationStepFour.vue?vue&type=style&index=0&id=148f2da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f2da6",
  null
  
)

export default component.exports